import React from 'react';

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col justify-between bg-gray-50">
      
      {/* Header Section */}
      <header className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto flex justify-between items-center py-4 px-6">
          <h1 className="text-2xl font-bold text-green-600">Suwashti</h1>
          <nav className="space-x-4">
            <a href="/" className="text-gray-700 hover:text-green-600">Home</a>
            <a href="/about" className="text-gray-700 hover:text-green-600">About</a>
            <a href="/contact" className="text-gray-700 hover:text-green-600">Contact</a>
          </nav>
        </div>
      </header>

      {/* Main Section */}
      <main className="flex-grow">
        <section className="text-center py-16 px-4">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Welcome to Suwashti Employee Portal
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Simplifying your onboarding, document submission, and verification process. Stay updated and manage your details with ease.
          </p>
          <a href="/register" className="mt-6 inline-block bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-6 rounded-full transition">
            Get Started
          </a>
        </section>

        {/* Features Section */}
        <section className="bg-white py-12 px-4">
          <div className="max-w-6xl mx-auto grid gap-8 md:grid-cols-3">
            <div className="p-6 rounded-xl shadow hover:shadow-lg transition bg-gray-50 text-center">
              <h3 className="text-xl font-semibold text-green-600 mb-2">Easy Registration</h3>
              <p className="text-gray-600">
                Quickly submit your information and documents with our simple, user-friendly forms.
              </p>
            </div>
            <div className="p-6 rounded-xl shadow hover:shadow-lg transition bg-gray-50 text-center">
              <h3 className="text-xl font-semibold text-green-600 mb-2">Secure Verification</h3>
              <p className="text-gray-600">
                Your details are safely verified, ensuring smooth background checks and updates.
              </p>
            </div>
            <div className="p-6 rounded-xl shadow hover:shadow-lg transition bg-gray-50 text-center">
              <h3 className="text-xl font-semibold text-green-600 mb-2">Stay Informed</h3>
              <p className="text-gray-600">
                Receive real-time notifications on your registered email once your status is updated.
              </p>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-white text-center py-4 border-t">
        <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Suwashti. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Home;